<template>
  <div class="App-Top-Nav-Admin-H">
    <div class="App-Top-Nav-B"></div>
    <div class="App-Top-Nav">
      <!--  -->
      <!-- Left -->
      <div class="App-Top-Nav-Left" v-if="showLeft">
        <slot name="left" />
      </div>
      <!--  -->
      <!-- txt-center -->
      <div class="App-Top-Nav-Center" v-if="showMiddle">
        <slot name="center" />
      </div>
      <!--  -->
      <!-- Right -->
      <div class="App-Top-Nav-Right" v-if="showRight">
        <slot name="right" />
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    showLeft: { type: Boolean, default: true },
    showMiddle: { type: Boolean, default: true },
    showRight: { type: Boolean, default: true },
  },
  components: {},
})
export default class extends Vue {}
</script>

<style lang="scss">
$border-radius: map.get($--border-radius, "base");
$border-radius-s: map.get($--border-radius, "small");
$border-radius-t: $border-radius $border-radius $border-radius-s
  $border-radius-s !important;
.App-Top-Nav-Admin-H {
  border-radius: $border-radius-t;
  position: relative;
  // Back And Title
  .App-Top-Nav-B {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    border-radius: $border-radius-t;
    background-color: #ebf4f2;
    position: absolute;
    // opacity: 0.5;
  }
  // Main Nav
  .App-Top-Nav {
    min-height: map.get($--input-height, "default") * 2.5;
    border-radius: $border-radius-t;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: math.div(map.get($--input-height, "default"), 6) 6px;
  }

  // Left side
  .App-Top-Nav-Left {
    // width: 200px;
    // icon
    [class^="el-icon-"],
    [class*=" el-icon-"] {
      font-size: 20px;
      font-weight: bold;
      color: black;
    }
  }
  // txt-center side
  .App-Top-Nav-Center {
    //
    // Title
    [nav-title],
    [nav-title-med] {
      text-align: center;
      font-weight: bolder;
    }
    [nav-title] {
      font-size: map.get($--font-size, "large") + 2px;
    }
    [nav-title-med] {
      font-size: map.get($--font-size, "medium");
    }
  }
  .App-Top-Nav-Right {
    // width: 200px;
  }
}

//
.el-page-header {
  .el-page-header__title {
    font-weight: 700;
    font-size: 16px;
  }
  .el-page-header__content {
    font-size: 13px;
    color: var(--text-color-secondary);
  }
}
</style>
